/**
 * The names on the box (docs/spec/README, "Decisions you may want to overrule" #1). Change them
 * here and nowhere else.
 */
export const GAME_NAME = 'STARHIVE';
export const SHIP_NAME = 'LANCER';
export const ENEMY_NAMES = { stinger: 'STINGER', moth: 'MOTH', monarch: 'MONARCH', empress: 'EMPRESS' } as const;
export const VERSION = '0.1.0';
export const TRIBUTE =
  'A tribute to Galaga (1981) by Namco. '
  + 'STARHIVE is not affiliated with or endorsed by Bandai Namco Entertainment.';
